<form [formGroup]="form.formGroup" bg-dark>
  <div class="flex flex-col space-y-2">

    @if (currentString.type == 'Tubing') {
      <div class="pb-2">
        <p-checkbox
        size="small"
        binary="true"
        [formControlName]="form.formControlNames.isLeakAtHanger"
        inputId="tubingLeak"
      />
        <label class="ml-2" for="tubingLeak">Model Tubing Leak</label>
      </div>
    }

    <div class="flex flex-col">
      <label [class.opacity-50]="form.formGroup.controls.isLeakAtHanger.value">{{ topPressureLabel }}</label>
        @if (!form.formGroup.controls.isLeakAtHanger.value) {
          <app-validated-number-input
            [id]="'hangerPressure'"
            [control]="control('hangerPressure')"
            [value]="control('hangerPressure').value"
            [validation]="pressureValidation"
            [unit]="userUnits.pressure"
            [unitPrecisionOverrides]="{ 'psi': 3, 'bar': 3, 'KPa': 3, 'atm': 3 }"
          ></app-validated-number-input>

        } @else {
         <p-inputgroup>
          <p-inputNumber [placeholder]="tubingLeakDensity" disabled="true"></p-inputNumber>
          <p-inputgroup-addon [class.opacity-50]="form.formGroup.controls.isLeakAtHanger.value">{{ userUnits.pressure }}</p-inputgroup-addon>
        </p-inputgroup>
        }
    </div>

    <div class="flex flex-col">
      <label>Fluid Density</label>
      <app-validated-number-input
        [id]="'fluidDensity'"
        [control]="control('fluidDensity')"
        [value]="control('fluidDensity').value"
        [validation]="densityValidation"
        [unit]="densityLabel"
        [unitPrecisionOverrides]="{ 'ppg': 3, 'g/L': 3, 'kg/l': 3, 'g/cm³': 3, 'g/m³': 3, 'kg/m³': 3, 'sg': 3 }"
      ></app-validated-number-input>
    </div>

    <p-fieldset [hidden]="hideDeterioratedMudOption" class="pt-2 pb-2">
      <ng-template pTemplate="header">
        <div class="flex align-items-center h-5">
          <p-toggleswitch (onChange)="hasDeterioratedMudChange()" formControlName="hasDeterioratedMud" inputId="hasDeterioratedMud"
            binary="true">
          </p-toggleswitch>
          <label class="ml-2" for="hasDeterioratedMud"> Deteriorated Mud</label>
        </div>
      </ng-template>

      <div class="flex flex-col pb-3">
        <label>Base Fluid Density</label>
        <app-validated-number-input
          [id]="'deterioratedMudDensity'"
          [control]="control('deterioratedMudDensity')"
          [value]="control('deterioratedMudDensity').value"
          [validation]="densityValidation"
          [unit]="densityLabel"
          [unitPrecisionOverrides]="{ 'ppg': 3, 'g/L': 3, 'kg/l': 3, 'g/cm³': 3, 'g/m³': 3, 'kg/m³': 3, 'sg': 3 }"
        ></app-validated-number-input>
      </div>
    </p-fieldset>
  </div>
</form>
